import { reportModalActionTypes } from './Constants';

const initialState = {
	loading: false,
	open: false,
	reportOptions: [],
	reportType: '',
	reportItemId: null,
};

export default function reportModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case reportModalActionTypes.TOGGLE_REPORT_MODAL:
		case reportModalActionTypes.GET_REPORT_OPTIONS_SUCCESS:
		case reportModalActionTypes.SET_REPORT_ITEM_ID:
		case reportModalActionTypes.SEND_REPORT_SUCCESS:
			return {
				...state,
				...data,
			};

		case reportModalActionTypes.GET_REPORT_OPTIONS_ERROR:
			return {
				loading: false,
				open: false,
				reportOptions: [],
				reportType: '',
			};

		case reportModalActionTypes.SEND_REPORT_REQUEST:
			return {
				...state,
				loading: true,
			};

		case reportModalActionTypes.SEND_REPORT_ERROR:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
